import Vue from 'vue';

export default [
    {
        pathId: 'crs',
        component: 'certifications',
        title: 'Certifications',
        icon: 'fa-certificate',
        size: 'sm',
        loading: true
    }, {
        pathId: 'crn',
        component: 'new-certification',
        title: 'New Certification',
        icon: 'fa-plus',
        size: 'md'
    }, {
        pathId: 'cre',
        component: 'edit-certification',
        title: 'Edit Certification',
        icon: 'fa-pencil',
        size: 'md',
        props: ['certificationId'],
        loading: true
    }, {
        pathId: 'wiaacl',
        component: 'wiaa-certification-lookup',
        title: 'WIAA Cert Lookup',
        icon: 'fa-search-plus',
        size: 'sm',
    }, {
        pathId: 'wiaacs',
        component: 'wiaa-certification-search',
        title: 'WIAA Cert Search',
        icon: 'fa-search',
        size: 'md',
        props: ['query'],
        loading: true
    }, {
        pathId: 'wiaacd',
        component: 'wiaa-certification-details',
        title: 'WIAA Certification Details',
        icon: 'fa-certificate',
        size: 'md',
        props: ['userId'],
        loading: true
    }, {
        pathId: 'wiaaid',
        component: 'wiaa-edit-id',
        title: 'Edit WIAA ID',
        icon: 'fa-id-badge',
        size: 'sm',
        props: ['userId'],
        loading: true
    }
];

Vue.component('certifications', () => import('@/cards/certifications/Certifications'));
Vue.component('new-certification', () => import('@/cards/certifications/NewCertification'));
Vue.component('edit-certification', () => import('@/cards/certifications/EditCertification'));
Vue.component('wiaa-certification-lookup', () => import('@/cards/certifications/WiaaCertificationLookup'));
Vue.component('wiaa-certification-search', () => import('@/cards/certifications/WiaaCertificationSearch'));
Vue.component('wiaa-certification-details', () => import('@/cards/certifications/WiaaCertificationDetails'));
Vue.component('wiaa-edit-id', () => import('@/cards/certifications/WiaaEditId'));
